const PLANNING_TABLE_BREAKOUT_HORIZONTAL_GUTTER_PX = 120;

export const getPlanningBreakoutStyle = ({
  windowWidth,
  editorWidth,
  buttonOffset,
  desiredReserveRightPx = 0,
  tableWidthPx,
  fillsContainer = false,
}: {
  windowWidth: number;
  editorWidth: number;
  buttonOffset: number;
  desiredReserveRightPx?: number;
  tableWidthPx: number;
  fillsContainer?: boolean;
}): {widthPx: number; marginLeftPx: number} => {
  const fullWidthPx = Math.max(
    editorWidth,
    windowWidth - PLANNING_TABLE_BREAKOUT_HORIZONTAL_GUTTER_PX - buttonOffset
  );

  // Dynamic node tables (DSYS Table with CSS grid) stretch to fill the
  // breakout container, so their column-sum underreports the rendered width.
  const effectiveTableWidthPx = fillsContainer ? fullWidthPx : tableWidthPx;

  // Only reserve right space if the table is wide enough to overlap it.
  // *2 because the table is centered, so reserve must fit on both sides.
  const reserveRightPx =
    desiredReserveRightPx > 0 && effectiveTableWidthPx > fullWidthPx - desiredReserveRightPx * 2
      ? desiredReserveRightPx
      : 0;

  return {
    widthPx: Math.max(editorWidth, fullWidthPx - reserveRightPx),
    marginLeftPx:
      -(windowWidth - editorWidth - PLANNING_TABLE_BREAKOUT_HORIZONTAL_GUTTER_PX - buttonOffset) /
        2 +
      buttonOffset,
  };
};
